import { I18n } from 'aws-amplify';
import { buildListCategoriesMessage, checkMessageOutOfSession, postMessage } from './handler/ChatBoxHandler';
import { memo, useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { updatePreviewSettingAtom } from '@/state/atom/chatBotPreview';
import DisplayOptionBySetting from './DisplayOptionBySetting';
import { getOptionDisplayLength } from './handler/ChatBoxHandler';

function ListTagField({
    message,
    onClickHandler,
    chatbotSettings,
    listCategories,
    setMessages,
    supportThreadIdState,
    affiliationOrganization,
    messages,
    listTagFieldSelected,
    isModePreview,
    isMaximizedPanel
}) {
    const [maxNumberAnswer, setMaxNumberAnswer] = useState(0);
    const previewSetting = useRecoilValue(updatePreviewSettingAtom);
    const [messageState, setMessagesState] = useState(message)
    useEffect(() =>{
        if (message.idMessage !== messageState.idMessage) {
            setMessagesState(message)
        }
    }, [message])

    useEffect(() => {
        if (!isModePreview) {
            setMaxNumberAnswer(chatbotSettings.maxNumberAnswer);
        }
    }, [chatbotSettings]);

    useEffect(() => {
        if (isModePreview) {
            if (previewSetting.maxNumberAnswer !== maxNumberAnswer) {
                setMaxNumberAnswer(previewSetting.maxNumberAnswer);
            }
        }
    }, [previewSetting]);

    let isShowSeeMore = maxNumberAnswer < messageState?.content?.length;

    const onClickBackToListFormHandler = () => {
        if (checkMessageOutOfSession(messages, messageState.idMessage)) return;
        const nextMessage = buildListCategoriesMessage(listCategories);
        postMessage(
            nextMessage,
            supportThreadIdState,
            affiliationOrganization,
            false,
            isModePreview
        );
        setMessages(pev => [...pev, nextMessage]);
    };

    return (
        <div className={isMaximizedPanel ? 'message-text  maximized-form-text' : 'message-text'}>
            <div className="text-question">{I18n.get(messageState?.usingAI ? 'CBOTMSG002-AI-ON' : 'CBOTMSG002')}</div>
            {messageState?.content?.slice(0, maxNumberAnswer)?.map(option => (
                <DisplayOptionBySetting 
                    key={option.id}
                    label={option.name}
                    optionDisplayLength={getOptionDisplayLength(chatbotSettings, previewSetting)}
                    onClickHandler={() => onClickHandler(option, messageState.idMessage)}
                    isMaximizedPanel={isMaximizedPanel}
                />
                // <OverFlowTooltipWithTabsMui
                //     className={`option-form ${isMaximizedPanel ? 'maximized-form': 'minimized-form'}`}
                //     onClick={e => {
                //         onClickHandler(option, messageState.idMessage);
                //     }}
                //     value={option.name}
                //     key={option.id}
                // />
            ))}
            {isShowSeeMore && <div className="option-seemore">{I18n.get('CBOTMSG005')}</div>}
            {messageState.isDisplayBackBtn && (
                <div className="btn-back-tagfield" onClick={onClickBackToListFormHandler}>
                    {/* <img src="/assets/image/icon-back-chatbot.svg" alt="sss" /> */}
                    <span className="text-btn-back">{`< 戻る`}</span>
                </div>
            )}
        </div>
    );
}

export default memo(ListTagField)
